<template>
  <div id="BoxProcessingResult" class="processing-result-card">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off" @submit.prevent="handleSubmit(saveResult)">
        <div class="processing-form-wrap">
          <div v-loading="loadingShowInfo" class="row">
            <div class="col-md-12">
              <label class="processing-label">Trạng thái<span class="text-danger"> *</span></label>
              <ValidationProvider vid="status" name="Trạng thái" rules="required" v-slot="{ errors }">
                <el-select
                  size="large"
                  v-model="query.status"
                  placeholder="Chọn trạng thái..."
                  clearable
                  class="w-100"
                  filterable
                >
                  <el-option
                    v-for="item in LOGISTICS_STATUSES"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <div class="fv-plugins-message-container">
                  <div data-field="status" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>

            <div class="col-md-12 mt-4">
              <label class="processing-label">Ghi chú xử lý</label>
              <ValidationProvider
                vid="Ghi chú"
                name="Ghi chú"
                :rules="{ max: 300 }"
                v-slot="{ errors }"
              >
                <div class="editor-wrap">
                  <ckeditor class="position-relative" :editor="editor" v-model="query.note"></ckeditor>
                </div>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="processing-actions">
          <button
            type="button"
            @click="dialogConfirm = true"
            class="btn btn-secondary font-weight-bold mr-2"
            :disabled="loading"
          >
            Quay lại
          </button>
          <button
            type="submit"
            class="btn btn-primary font-weight-bold"
            :disabled="loading || !canSubmit"
          >
            <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
            {{ loading ? "Đang lưu..." : "Lưu kết quả" }}
          </button>
        </div>
      </form>
    </ValidationObserver>

    <el-dialog
      id="dialogConfirmResultPhone"
      width="30%"
      title="Rời trang?"
      :visible.sync="dialogConfirm"
      top="25vh"
    >
      <div class="confirm-message">
        <span>Kết quả xử lý của bạn chưa được lưu.</span><br />
        <span>Bạn có chắc chắn muốn rời trang?</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <button type="button" class="btn btn-secondary font-weight-bold mr-2" @click="switchBox">Rời đi</button>
        <button type="button" class="btn btn-primary font-weight-bold" @click="dialogConfirm = false">Ở lại</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { LOGISTICS_STATUSES } from "@/core/option/logisticsOption";
import { SAVE_PROCESSING_RESULT } from "@/core/services/store/logistics/logistics.module";
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";

export default {
  name: "ResultProcessingComponent",
  props: {
    requestId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      dialogConfirm: false,
      loadingShowInfo: false,
      LOGISTICS_STATUSES,
      editor: CustomEditor,
      query: {
        status: "",
        note: "",
      },
    };
  },
  computed: {
    canSubmit() {
      return Boolean(this.query.status);
    },
  },
  methods: {
    switchBox() {
      this.$emit("showBoxResult", false);
    },
    saveResult() {
      this.loading = true;
      const payload = {
        request_id: this.requestId,
        status: this.query.status,
        note: this.query.note,
      };

      this.$store.dispatch(SAVE_PROCESSING_RESULT, payload).then((res) => {
        if (!res.error) {
          this.$notify({
            title: "Thành công",
            message: "Lưu kết quả xử lý thành công",
            type: "success",
          });
          this.$emit("loadData");
          this.switchBox();
        }
      }).catch((e) => {
        this.$notify.error({
          title: "Lỗi",
          message: `${e?.data?.message || "Có lỗi xảy ra"}`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style>
#dialogConfirmResultPhone .el-dialog__body {
  padding: 13px 20px;
}

#BoxProcessingResult.processing-result-card {
  border: 1px solid #dbe7ff !important;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
  overflow: hidden;
}

#BoxProcessingResult .processing-form-wrap {
  padding: 18px 18px 8px;
}

#BoxProcessingResult .processing-label {
  display: block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}


#BoxProcessingResult .processing-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 18px;
  border-top: 1px solid #edf2f7;
  background: #f8fbff;
}

#BoxProcessingResult .confirm-message {
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  word-break: initial !important;
  color: #334155;
  line-height: 1.8;
}
</style>
